export interface CourseData {
    name: string;
    ctv_order: number;
    par: number[];
    elite: number[];
}

const ShortName = {
    SunshineGlade : "SG",
    BlueberryThicket : "BT",
    OakHill : "OH",
    Lakeside : "LS",
    WindsweptFields : "WF",
    HarrowingWoods : "HW",
    CrowsNest : "CN",
    GrizzlyGulch : "GG",
    Owlwood : "OW",
    KahoPark : "KP",
    CoyoteCanyon : "CC" ,
    KahoBackwoods : "KB",
    FrozenValley : "FV",
    Downtown : "DT",
    LostIsland : "LI",
    PioneerBay : "PB",
    IkigaiSprings : "IS",
    NorthernLights : "NL",
    HighlandersRidge : "HR",
    EmporiaCountryClub : "EC",
    NokiaDiscGolfPark : "ND",
    IkigaiEnso : "IE",
    NorthernBreeze : "NB",
    MapleHill : "MH",
    FoxtailMeadows : "FM",
    KalevalaLegends : "KL",
    SmoothieLand : "SL",
    TheValleyBelow : "VB",
    SpaceVoyage : "SV",
    PaperTrail : "PT",
};

const Courses = {
    [ShortName.SunshineGlade]: {
        courseName: "Sunshine Glade",
        shortName: ShortName.SunshineGlade,
        holeCount: 5,
        releaseDay: new Date("2020-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.BlueberryThicket]: {
        courseName: "Blueberry Thicket",
        shortName: ShortName.BlueberryThicket,
        holeCount: 9,
        releaseDay: new Date("2020-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.OakHill]: {
        courseName: "Oak Hill",
        shortName: ShortName.OakHill,
        holeCount: 9,
        releaseDay: new Date("2020-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.Lakeside]: {
        courseName: "Lakeside",
        shortName: ShortName.Lakeside,
        holeCount: 9,
        releaseDay: new Date("2020-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.WindsweptFields]: {
        courseName: "Windswept Fields",
        shortName: ShortName.WindsweptFields,
        holeCount: 9,
        releaseDay: new Date("2020-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.HarrowingWoods]: {
        courseName: "Harrowing Woods",
        shortName: ShortName.HarrowingWoods,
        holeCount: 9,
        releaseDay: new Date("2020-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.CrowsNest]: {
        courseName: "Crows Nest",
        shortName: ShortName.CrowsNest,
        holeCount: 9,
        releaseDay: new Date("2020-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.GrizzlyGulch]: {
        courseName: "Grizzly Gulch",
        shortName: ShortName.GrizzlyGulch,
        holeCount: 9,
        releaseDay: new Date("2020-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.Owlwood]: {
        courseName: "Owlwood",
        shortName: ShortName.Owlwood,
        holeCount: 9,
        releaseDay: new Date("2020-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.KahoPark]: {
        courseName: "Kaho Park",
        shortName: ShortName.KahoPark,
        holeCount: 9,
        releaseDay: new Date("2020-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.CoyoteCanyon]: {
        courseName: "Coyote Canyon",
        shortName: ShortName.CoyoteCanyon,
        holeCount: 9,
        releaseDay: new Date("2020-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.KahoBackwoods]: {
        courseName: "Kaho Backwoods",
        shortName: ShortName.KahoBackwoods,
        holeCount: 9,
        releaseDay: new Date("2020-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.FrozenValley]: {
        courseName: "Frozen Valley",
        shortName: ShortName.FrozenValley,
        holeCount: 9,
        releaseDay: new Date("2020-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.Downtown]: {
        courseName: "Downtown",
        shortName: ShortName.Downtown,
        holeCount: 9,
        releaseDay: new Date("2020-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.LostIsland]: {
        courseName: "Lost Island",
        shortName: ShortName.LostIsland,
        holeCount: 9,
        releaseDay: new Date("2020-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.PioneerBay]: {
        courseName: "Pioneer Bay",
        shortName: ShortName.PioneerBay,
        holeCount: 9,
        releaseDay: new Date("2022-11-23"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.IkigaiSprings]: {
        courseName: "Ikigai Springs",
        shortName: ShortName.IkigaiSprings,
        holeCount: 9,
        releaseDay: new Date("2020-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.NorthernLights]: {
        courseName: "Northern Lights",
        shortName: ShortName.NorthernLights,
        holeCount: 9,
        releaseDay: new Date("2022-11-31"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.HighlandersRidge]: {
        courseName: "Highlander's Ridge",
        shortName: ShortName.HighlandersRidge,
        holeCount: 9,
        releaseDay: new Date("2023-05-02"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.EmporiaCountryClub]: {
        courseName: "Emporia Country Club",
        shortName: ShortName.EmporiaCountryClub,
        holeCount: 18,
        releaseDay: new Date("2023-05-02"),
        configurationHoleCounts : [18, 18, 18],
        enabledConfigurations : [1, 2],
    },
    [ShortName.NokiaDiscGolfPark]: {
        courseName: "Nokia DiscGolfPark",
        shortName: ShortName.NokiaDiscGolfPark,
        holeCount: 18,
        releaseDay: new Date("2023-05-02"),
        configurationHoleCounts : [18],
        enabledConfigurations : [0],
    },
    [ShortName.IkigaiEnso]: {
        courseName: "Ikigai Enso",
        shortName: ShortName.IkigaiEnso,
        holeCount: 9,
        releaseDay: new Date("2023-07-30"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.NorthernBreeze]: {
        courseName: "Northern Breeze",
        shortName: ShortName.NorthernBreeze,
        holeCount: 9,
        releaseDay: new Date("2023-10-26"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.MapleHill]: { 
        courseName: "Maple Hill",
        shortName: ShortName.MapleHill,
        holeCount: 18,
        releaseDay: new Date("2023-12-19"),
        configurationHoleCounts : [18, 18, 18],
        enabledConfigurations : [0, 1, 2],
    },
    [ShortName.FoxtailMeadows]: { 
        courseName: "Foxtail Meadows",
        shortName: ShortName.FoxtailMeadows,
        holeCount: 9,
        releaseDay: new Date("2023-12-19"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.KalevalaLegends]: { 
        courseName: "Kalevala Legends",
        shortName: ShortName.KalevalaLegends,
        holeCount: 9,
        releaseDay: new Date("2023-12-19"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.SmoothieLand]: { 
        courseName: "Smoothie Land",
        shortName: ShortName.SmoothieLand,
        holeCount: 9,
        releaseDay: new Date("2023-12-19"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.TheValleyBelow]: { 
        courseName: "The Valley Below",
        shortName: ShortName.TheValleyBelow,
        holeCount: 9,
        releaseDay: new Date("2023-12-19"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.SpaceVoyage]: { 
        courseName: "Space Voyage",
        shortName: ShortName.SpaceVoyage,
        holeCount: 9,
        releaseDay: new Date("2026-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
    [ShortName.PaperTrail]: { 
        courseName: "Paper Trail",
        shortName: ShortName.PaperTrail,
        holeCount: 9,
        releaseDay: new Date("2026-01-01"),
        configurationHoleCounts : [],
        enabledConfigurations : [],
    },
};

export const HOLE_PREFIX_TO_DATA: { [key: string]: CourseData } = {
    'SG': {
        name: 'Sunshine Glade',
        ctv_order: 1,
        par: [3, 3, 3, 3, 4],
        elite: [2, 2, 2, 2, 2],
    },
    'BT': {
        name: 'Blueberry Thicket',
        ctv_order: 2,
        par: [3, 3, 4, 3, 3, 3, 3, 3, 3],
        elite: [2, 2, 2, 2, 2, 2, 2, 2, 2]
    },
    'OH': {
        name: 'Oak Hill',
        ctv_order: 3,
        par: [4, 3, 4, 4, 4, 4, 4, 4, 3],
        elite: [2, 2, 2, 2, 2, 2, 2, 2, 2]
    },
    'LS': {
        name: 'Lakeside',
        ctv_order: 4,
        par: [3, 4, 3, 5, 4, 3, 3, 3, 5],
        elite: [2, 2, 2, 2, 3, 2, 2, 2, 3]
    },
    'WF': {
        name: 'Windswept Fields',
        ctv_order: 5,
        par: [3, 4, 4, 3, 4, 3, 3, 3, 3],
        elite: [2, 2, 2, 2, 2, 2, 2, 2, 2]
    },
    'HW': {
        name: 'Harrowing Woods',
        ctv_order: 6,
        par: [3, 3, 3, 3, 4, 4, 3, 4, 5],
        elite: [2, 2, 2, 2, 2, 2, 2, 3, 3]
    },
    'CN': {
        name: 'Crows Nest',
        ctv_order: 7,
        par: [3, 3, 4, 4, 3, 3, 4, 3, 4],
        elite: [2, 2, 2, 2, 2, 2, 2, 2, 3]
    },
    'GG': {
        name: 'Grizzly Gulch',
        ctv_order: 8,
        par: [3, 3, 4, 3, 4, 4, 3, 4, 3],
        elite: [2, 2, 2, 2, 2, 2, 2, 3, 2]
    },
    'OW': {
        name: 'Owlwood',
        ctv_order: 9,
        par: [3, 4, 3, 3, 3, 3, 3, 4, 3],
        elite: [2, 3, 2, 2, 2, 2, 2, 3, 2]
    },
    'HR': {
        name: 'Highlander\'s Ridge',
        ctv_order: 10,
        par: [3, 3, 4, 4, 4, 3, 3, 4, 3],
        elite: [2, 2, 3, 3, 3, 2, 2, 3, 2]
    },
    'KP': {
        name: 'Kaho Park',
        ctv_order: 11,
        par: [3, 5, 3, 4, 3, 4, 5, 3, 3],
        elite: [2, 3, 2, 3, 2, 3, 3, 2, 2]
    },
    'CC': {
        name: 'Coyote Canyon',
        ctv_order: 12,
        par: [3, 4, 4, 3, 4, 3, 3, 3, 4],
        elite: [2, 3, 3, 2, 2, 2, 2, 2, 3]
    },
    'KB': {
        name: 'Kaho Backwoods',
        ctv_order: 13,
        par: [3, 4, 3, 5, 3, 3, 3, 4, 4],
        elite: [2, 3, 2, 3, 2, 2, 2, 3, 2]
    },
    'FV': {
        name: 'Frozen Valley',
        ctv_order: 14,
        par: [3, 5, 4, 4, 4, 3, 3, 3, 4],
        elite: [2, 4, 3, 3, 3, 2, 2, 2, 3]
    },
    'DT': {
        name: 'Downtown',
        ctv_order: 15,
        par: [4, 3, 3, 4, 5, 5, 3, 4, 3],
        elite: [3, 2, 2, 3, 3, 3, 2, 3, 2]
    },
    'LI': {
        name: 'Lost Island',
        ctv_order: 16,
        par: [3, 3, 4, 3, 4, 4, 3, 5, 4],
        elite: [2, 2, 3, 2, 3, 3, 2, 3, 3]
    },
    'PB': {
        name: 'Pioneer Bay',
        ctv_order: 17,
        par: [4, 4, 5, 3, 3, 4, 4, 5, 4],
        elite: [3, 3, 4, 2, 2, 3, 3, 4, 3]
    },
    'IS': {
        name: 'Ikigai Springs',
        ctv_order: 18,
        par: [4, 3, 5, 4, 3, 3, 5, 4, 4],
        elite: [3, 2, 3, 3, 2, 2, 4, 2, 3]
    },
    'NL': {
        name: 'Northern Lights',
        ctv_order: 19,
        par: [4, 3, 4, 4, 3, 3, 5, 4, 3],
        elite: [3, 2, 3, 3, 2, 2, 4, 3, 2]
    },
    'IE': {
        name: 'Ikigai Enso',
        ctv_order: 20,
        par: [4, 4, 4, 4, 4, 4, 4, 4, 4],
        elite: [3, 3, 3, 3, 2, 2, 3, 3, 2]
    },
    'NB': {
        name: 'Northern Breeze',
        ctv_order: 21,
        par: [3, 3, 3, 3, 3, 3, 4, 3, 3],
        elite: [2, 2, 2, 2, 2, 2, 3, 2, 2]
    },
    'EC': {
        name: 'Champions Landing MPO 2022',
        ctv_order: 22,
        par: [5, 4, 3, 3, 4, 3, 4, 5, 4, 3, 3, 3, 3, 4, 3, 3, 4, 4],
        elite: [4, 3, 2, 2, 3, 2, 3, 4, 3, 2, 2, 2, 2, 3, 2, 2, 3, 3],
    },
    'ND': {
        name: 'Nokia "The Beast"',
        ctv_order: 23,
        par: [3, 3, 5, 4, 3, 3, 4, 3, 3, 4, 3, 4, 4, 3, 3, 4, 3, 4],
        elite: [2, 2, 4, 3, 2, 2, 3, 2, 2, 3, 2, 3, 3, 2, 2, 3, 2, 3]
    },
    'MHG': {
        name: 'Maple Hill Gold',
        ctv_order: 24,
        par: [4, 3, 3, 3, 3, 3, 3, 3, 4, 3, 4, 4, 3, 3, 3, 3, 4, 4],
        elite: [3, 2, 2, 2, 2, 2, 2, 2, 3, 2, 3, 3, 2, 2, 2, 2, 3, 3]
    },
    'MHD': {
        name: 'Maple Hill Diamond',
        ctv_order: 25,
        par: [4, 3, 3, 3, 3, 3, 3, 3, 4, 3, 4, 4, 3, 3, 3, 3, 4, 4],
        elite: [3, 2, 2, 2, 2, 2, 2, 2, 3, 2, 3, 3, 2, 2, 2, 2, 3, 3]
    },
    'MHR': {
        name: 'Maple Hill Red',
        ctv_order: 26,
        par: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3],
        elite: [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2]
    },
    'CLMPO': {
        name: 'Champions Landing MPO 2024',
        ctv_order: 27,
        par: [5, 4, 3, 3, 4, 3, 4, 5, 4, 4, 3, 3, 3, 5, 3, 3, 4, 5],
        elite: [4, 3, 2, 2, 3, 2, 3, 4, 3, 3, 2, 2, 2, 4, 2, 2, 3, 4],
    },
    'CLFPO': {
        name: 'Champions Landing FPO 2024',
        ctv_order: 27,
        par: [5, 4, 4, 4, 4, 3, 4, 5, 5, 4, 3, 3, 4, 5, 3, 3, 4, 4],
        elite: [3, 3, 2, 2, 2, 2, 2, 4, 3, 3, 2, 2, 2, 3, 2, 2, 3, 3],
    },
    'MHG2024': {
        name: 'Maple Hill Gold 2024',
        ctv_order: 28,
        par: [4, 3, 3, 3, 3, 3, 3, 3, 5, 3, 4, 4, 3, 3, 3, 3, 4, 4],
        elite: [3, 2, 2, 2, 2, 2, 2, 2, 4, 2, 3, 3, 2, 2, 2, 2, 3, 3]
    },
    'FM': {
        name: 'Foxtail Meadows',
        ctv_order: 29,
        par: [4, 3, 4, 5, 4, 3, 3, 4, 5],
        elite: [2, 2, 3, 3, 2, 2, 2, 3, 3]
    },
    'KL': {
        name: 'Kalevala Legends',
        ctv_order: 30,
        par: [3, 3, 3, 5, 4, 4, 3, 4, 5],
        elite: [2, 2, 4, 3, 2, 2, 3, 2, 2]
    },
    'SL': {
        name: 'Smoothie Land',
        ctv_order: 31,
        par: [4, 3, 4, 4, 4, 4, 4, 3, 4],
        elite: [2, 2, 4, 3, 2, 2, 3, 2, 2]
    },
    'VB': {
        name: 'The Valley Below',
        ctv_order: 32,
        par: [3, 3, 4, 4, 4, 4, 4, 4, 3],
        elite: [2, 2, 4, 3, 2, 2, 3, 2, 2]
    },
    'SV': {
        name: 'Space Voyage',
        ctv_order: 33,
        par: [3, 4, 5, 5, 5, 5, 5, 3, 3],
        elite: [2, 3, 4, 4, 4, 4, 4, 2, 2]
    },
    'PT': {
        name: 'Paper Trail',
        ctv_order: 34,
        par: [3, 3, 4, 4, 3, 4, 5, 3, 4],
        elite: [2, 2, 3, 3, 2, 3, 4, 2, 3]
    },
};

interface HoleToScene {
    [key: string]: string;
}

export const HOLE_TO_SCENE: HoleToScene = {
    // Sunshine Glade
    'SG1': 'C1H1',
    'SG2': 'C1H2',
    'SG3': 'C1H3',
    'SG4': 'C1H4',
    'SG5': 'C1H5',

    // Blueberry Thicket
    'BT1': 'C2H1',
    'BT2': 'C2H2',
    'BT3': 'C2H3',
    'BT4': 'C2H4',
    'BT5': 'C2H5',
    'BT6': 'C2H6',
    'BT7': 'C2H7',
    'BT8': 'C2H8',
    'BT9': 'C2H9',

    // Oak Hill
    'OH1': 'C3H1',
    'OH2': 'C3H2',
    'OH3': 'C3H3',
    'OH4': 'C3H4',
    'OH5': 'C3H5',
    'OH6': 'C3H6',
    'OH7': 'C3H7',
    'OH8': 'C3H8',
    'OH9': 'C3H9',

    // Lakeside
    'LS1': 'C4H1',
    'LS2': 'C4H2',
    'LS3': 'C4H3',
    'LS4': 'C4H4',
    'LS5': 'C4H5',
    'LS6': 'C4H6',
    'LS7': 'C4H7',
    'LS8': 'C4H8',
    'LS9': 'C4H9',

    // Windswept Fields
    'WF1': 'C5H1',
    'WF2': 'C5H2',
    'WF3': 'C5H3',
    'WF4': 'C5H4',
    'WF5': 'C5H5',
    'WF6': 'C5H6',
    'WF7': 'C5H7',
    'WF8': 'C5H8',
    'WF9': 'C5H9',

    // Harrowing Woods
    'HW1': 'C6H1',
    'HW2': 'C6H2',
    'HW3': 'C6H3',
    'HW4': 'C6H4',
    'HW5': 'C6H5',
    'HW6': 'C6H6',
    'HW7': 'C6H7',
    'HW8': 'C6H8',
    'HW9': 'C6H9',

    // Crows Nest
    'CN1': 'C7H1',
    'CN2': 'C7H2',
    'CN3': 'C7H3',
    'CN4': 'C7H4',
    'CN5': 'C7H5',
    'CN6': 'C7H6',
    'CN7': 'C7H7',
    'CN8': 'C7H8',
    'CN9': 'C7H9',

    // Grizzly Gulch
    'GG1': 'C8H1',
    'GG2': 'C8H2',
    'GG3': 'C8H3',
    'GG4': 'C8H4',
    'GG5': 'C8H5',
    'GG6': 'C8H6',
    'GG7': 'C8H7',
    'GG8': 'C8H8',
    'GG9': 'C8H9',

    // Kaho Park
    'KP1': 'C9H1',
    'KP2': 'C9H2',
    'KP3': 'C9H3',
    'KP4': 'C9H4',
    'KP5': 'C9H5',
    'KP6': 'C9H6',
    'KP7': 'C9H7',
    'KP8': 'C9H8',
    'KP9': 'C9H9',

    // Owlwood
    'OW1': 'C10H1',
    'OW2': 'C10H2',
    'OW3': 'C10H3',
    'OW4': 'C10H4',
    'OW5': 'C10H5',
    'OW6': 'C10H6',
    'OW7': 'C10H7',
    'OW8': 'C10H8',
    'OW9': 'C10H9',

    // Coyote Canyon
    'CC1': 'C11H1',
    'CC2': 'C11H2',
    'CC3': 'C11H3',
    'CC4': 'C11H4',
    'CC5': 'C11H5',
    'CC6': 'C11H6',
    'CC7': 'C11H7',
    'CC8': 'C11H8',
    'CC9': 'C11H9',

    // Kaho Backwoods
    'KB1': 'C12H1',
    'KB2': 'C12H2',
    'KB3': 'C12H3',
    'KB4': 'C12H4',
    'KB5': 'C12H5',
    'KB6': 'C12H6',
    'KB7': 'C12H7',
    'KB8': 'C12H8',
    'KB9': 'C12H9',

    // Foxtail Meadows
    'FM1': 'FM01',
    'FM2': 'FM02',
    'FM3': 'FM03',
    'FM4': 'FM04',
    'FM5': 'FM05',
    'FM6': 'FM06',
    'FM7': 'FM07',
    'FM8': 'FM08',
    'FM9': 'FM09',

    // Frozen Valley
    'FV1': 'C13H1',
    'FV2': 'C13H2',
    'FV3': 'C13H3',
    'FV4': 'C13H4',
    'FV5': 'C13H5',
    'FV6': 'C13H6',
    'FV7': 'C13H7',
    'FV8': 'C13H8',
    'FV9': 'C13H9',

    // Downtown
    'DT1': 'C14H1',
    'DT2': 'C14H2',
    'DT3': 'C14H3',
    'DT4': 'C14H4',
    'DT5': 'C14H5',
    'DT6': 'C14H6',
    'DT7': 'C14H7',
    'DT8': 'C14H8',
    'DT9': 'C14H9',

    // Lost Island
    'LI1': 'CMnMH01',
    'LI2': 'CMnMH02',
    'LI3': 'CMnMH03',
    'LI4': 'CMnMH04',
    'LI5': 'CMnMH05',
    'LI6': 'CMnMH06',
    'LI7': 'CMnMH07',
    'LI8': 'CMnMH08',
    'LI9': 'CMnMH09',

    // Champions Landing 2022 MPO
    'EC1': 'ECC01',
    'EC2': 'ECC02',
    'EC3': 'ECC03',
    'EC4': 'ECC04',
    'EC5': 'ECC05',
    'EC6': 'ECC06',
    'EC7': 'ECC07',
    'EC8': 'ECC08',
    'EC9': 'ECC09',
    'EC10': 'ECC10',
    'EC11': 'ECC11',
    'EC12': 'ECC12',
    'EC13': 'ECC13',
    'EC14': 'ECC14',
    'EC15': 'ECC15',
    'EC16': 'ECC16',
    'EC17': 'ECC17',
    'EC18': 'ECC18',

    // Champions Landing 2024 MPO
    'CLMPO1': 'CL_MPO2024_01',
    'CLMPO2': 'CL_MPO2024_02',
    'CLMPO3': 'CL_MPO2024_03',
    'CLMPO4': 'CL_MPO2024_04',
    'CLMPO5': 'CL_MPO2024_05',
    'CLMPO6': 'CL_MPO2024_06',
    'CLMPO7': 'CL_MPO2024_07',
    'CLMPO8': 'CL_MPO2024_08',
    'CLMPO9': 'CL_MPO2024_09',
    'CLMPO10': 'CL_MPO2024_10',
    'CLMPO11': 'CL_MPO2024_11',
    'CLMPO12': 'CL_MPO2024_12',
    'CLMPO13': 'CL_MPO2024_13',
    'CLMPO14': 'CL_MPO2024_14',
    'CLMPO15': 'CL_MPO2024_15',
    'CLMPO16': 'CL_MPO2024_16',
    'CLMPO17': 'CL_MPO2024_17',
    'CLMPO18': 'CL_MPO2024_18',

    // Champions Landing 2024 FPO
    'CLFPO1': 'CL_FPO2024_01',
    'CLFPO2': 'CL_FPO2024_02',
    'CLFPO3': 'CL_FPO2024_03',
    'CLFPO4': 'CL_FPO2024_04',
    'CLFPO5': 'CL_FPO2024_05',
    'CLFPO6': 'CL_FPO2024_06',
    'CLFPO7': 'CL_FPO2024_07',
    'CLFPO8': 'CL_FPO2024_08',
    'CLFPO9': 'CL_FPO2024_09',
    'CLFPO10': 'CL_FPO2024_10',
    'CLFPO11': 'CL_FPO2024_11',
    'CLFPO12': 'CL_FPO2024_12',
    'CLFPO13': 'CL_FPO2024_13',
    'CLFPO14': 'CL_FPO2024_14',
    'CLFPO15': 'CL_FPO2024_15',
    'CLFPO16': 'CL_FPO2024_16',
    'CLFPO17': 'CL_FPO2024_17',
    'CLFPO18': 'CL_FPO2024_18',

    // Highlands Ridge
    'HR1': 'HIG01',
    'HR2': 'HIG02',
    'HR3': 'HIG03',
    'HR4': 'HIG04',
    'HR5': 'HIG05',
    'HR6': 'HIG06',
    'HR7': 'HIG07',
    'HR8': 'HIG08',
    'HR9': 'HIG09',

    // Ikigai Springs
    'IS1': 'MAR01',
    'IS2': 'MAR02',
    'IS3': 'MAR03',
    'IS4': 'MAR04',
    'IS5': 'MAR05',
    'IS6': 'MAR06',
    'IS7': 'MAR07',
    'IS8': 'MAR08',
    'IS9': 'MAR09',

    // Ikigai Enso
    'IE1': 'MAR10',
    'IE2': 'MAR11',
    'IE3': 'MAR12',
    'IE4': 'MAR13',
    'IE5': 'MAR14',
    'IE6': 'MAR15',
    'IE7': 'MAR16',
    'IE8': 'MAR17',
    'IE9': 'MAR18',

    // Nokia "The Beast"
    'ND1': 'NOK01',
    'ND2': 'NOK02',
    'ND3': 'NOK03',
    'ND4': 'NOK04',
    'ND5': 'NOK05',
    'ND6': 'NOK06',
    'ND7': 'NOK07',
    'ND8': 'NOK08',
    'ND9': 'NOK09',
    'ND10': 'NOK10',
    'ND11': 'NOK11',
    'ND12': 'NOK12',
    'ND13': 'NOK13',
    'ND14': 'NOK14',
    'ND15': 'NOK15',
    'ND16': 'NOK16',
    'ND17': 'NOK17',
    'ND18': 'NOK18',

    // Northern Lights
    'NL1': 'NOR01',
    'NL2': 'NOR02',
    'NL3': 'NOR03',
    'NL4': 'NOR04',
    'NL5': 'NOR05',
    'NL6': 'NOR06',
    'NL7': 'NOR07',
    'NL8': 'NOR08',
    'NL9': 'NOR09',

    // Northern Breeze
    'NB1': 'NOR10',
    'NB2': 'NOR11',
    'NB3': 'NOR12',
    'NB4': 'NOR13',
    'NB5': 'NOR14',
    'NB6': 'NOR15',
    'NB7': 'NOR16',
    'NB8': 'NOR17',
    'NB9': 'NOR18',

    // Pioner Bay
    'PB1': 'SJ01',
    'PB2': 'SJ02',
    'PB3': 'SJ03',
    'PB4': 'SJ04',
    'PB5': 'SJ05',
    'PB6': 'SJ06',
    'PB7': 'SJ07',
    'PB8': 'SJ08',
    'PB9': 'SJ09',

    // Maple Hill Gold
    'MHG1': 'MH01',
    'MHG2': 'MH02',
    'MHG3': 'MH03',
    'MHG4': 'MH04',
    'MHG5': 'MH05',
    'MHG6': 'MH06',
    'MHG7': 'MH07',
    'MHG8': 'MH08',
    'MHG9': 'MH09',
    'MHG10': 'MH10',
    'MHG11': 'MH11',
    'MHG12': 'MH12',
    'MHG13': 'MH13',
    'MHG14': 'MH14',
    'MHG15': 'MH15',
    'MHG16': 'MH16',
    'MHG17': 'MH17',
    'MHG18': 'MH18',

    // Maple Hill Diamond
    'MHD1': 'MH_FPO2023_01',
    'MHD2': 'MH_FPO2023_02',
    'MHD3': 'MH_FPO2023_03',
    'MHD4': 'MH_FPO2023_04',
    'MHD5': 'MH_FPO2023_05',
    'MHD6': 'MH_FPO2023_06',
    'MHD7': 'MH_FPO2023_07',
    'MHD8': 'MH_FPO2023_08',
    'MHD9': 'MH_FPO2023_09',
    'MHD10': 'MH_FPO2023_10',
    'MHD11': 'MH_FPO2023_11',
    'MHD12': 'MH_FPO2023_12',
    'MHD13': 'MH_FPO2023_13',
    'MHD14': 'MH_FPO2023_14',
    'MHD15': 'MH_FPO2023_15',
    'MHD16': 'MH_FPO2023_16',
    'MHD17': 'MH_FPO2023_17',
    'MHD18': 'MH_FPO2023_18',

    // Maple Hill Red
    'MHR1': 'MH_Reds_01',
    'MHR2': 'MH_Reds_02',
    'MHR3': 'MH_Reds_03',
    'MHR4': 'MH_Reds_04',
    'MHR5': 'MH_Reds_05',
    'MHR6': 'MH_Reds_06',
    'MHR7': 'MH_Reds_07',
    'MHR8': 'MH_Reds_08',
    'MHR9': 'MH_Reds_09',
    'MHR10': 'MH_Reds_10',
    'MHR11': 'MH_Reds_11',
    'MHR12': 'MH_Reds_12',
    'MHR13': 'MH_Reds_13',
    'MHR14': 'MH_Reds_14',
    'MHR15': 'MH_Reds_15',
    'MHR16': 'MH_Reds_16',
    'MHR17': 'MH_Reds_17',
    'MHR18': 'MH_Reds_18',

    // Maple Hill 2024 MPO
    'MHG_2024_1': '2024_MH_01',
    'MHG_2024_2': 'MH02',
    'MHG_2024_3': '2024_MH_03',
    'MHG_2024_4': 'MH04',
    'MHG_2024_5': 'MH05',
    'MHG_2024_6': '2024_MH_06',
    'MHG_2024_7': '2024_MH_07',
    'MHG_2024_8': 'MH08',
    'MHG_2024_9': '2024_MH_09',
    'MHG_2024_10': 'MH10',
    'MHG_2024_11': 'MH11',
    'MHG_2024_12': '2024_MH_12',
    'MHG_2024_13': 'MH13',
    'MHG_2024_14': '2024_MH_14',
    'MHG_2024_15': 'MH15',
    'MHG_2024_16': 'MH16',
    'MHG_2024_17': 'MH17',
    'MHG_2024_18': '2024_MH_18',

    // Kalevala Legends
    'KL1': 'WS01',
    'KL2': 'WS02',
    'KL3': 'WS03',
    'KL4': 'WS04',
    'KL5': 'WS05',
    'KL6': 'WS06',
    'KL7': 'WS07',
    'KL8': 'WS08',
    'KL9': 'WS09',

    // Smoothie Land
    'SL1': 'SL01',
    'SL2': 'SL02',
    'SL3': 'SL03',
    'SL4': 'SL04',
    'SL5': 'SL05',
    'SL6': 'SL06',
    'SL7': 'SL07',
    'SL8': 'SL08',
    'SL9': 'SL09',

    // The Valley Below
    'VB1': 'VB01',
    'VB2': 'VB02',
    'VB3': 'VB03',
    'VB4': 'VB04',
    'VB5': 'VB05',
    'VB6': 'VB06',
    'VB7': 'VB07',
    'VB8': 'VB08',
    'VB9': 'VB09',

    // Space Voyage
    'SV1': 'SV01',
    'SV2': 'SV02',
    'SV3': 'SV03',
    'SV4': 'SV04',
    'SV5': 'SV05',
    'SV6': 'SV06',
    'SV7': 'SV07',
    'SV8': 'SV08',
    'SV9': 'SV09',

    // Paper Trail
    'PT1': 'PTH1',
    'PT2': 'PTH2',
    'PT3': 'PTH3',
    'PT4': 'PTH4',
    'PT5': 'PTH5',
    'PT6': 'PTH6',
    'PT7': 'PTH7',
    'PT8': 'PTH8',
    'PT9': 'PTH9',
};
